import React, {useEffect, useState} from "react"
import {apiGet} from "../../../Api/index";
import {Row, Col, Div, Text} from "atomize";
import theme from "../../../Theme/Theme";
import styled from "styled-components";
import {SecondaryButton} from "../../Atoms/Button/index";
import ExperienceLayersSvg from "../../Molecules/ExperienceLayersSvg/index";
import Fade from 'react-reveal/Fade';


const Wrapper = styled(Row)`
  // border: 1px solid ${theme.colors.primary};
  // padding: 3rem 2rem;
  margin-top: 6rem;
  justify-content: space-between;
  position: relative;
  // background: white;
  
  // &:before {
  //   border: 1px solid ${theme.colors.primary};
  //   display: block;
  //   height: 100%;
  //   width: 100%;
  //   content: "";
  //   left: 5px;
  //   position: absolute;
  //   top: 5px;
  //   z-index: -1;
  // }
`;

const Intro = styled.div`
  p {
    color: ${theme.colors.grayDark};
    font-size: 20px;
    font-weight: 500;
    line-height: 32px;
  }
  
  @media only screen and (max-width: 766px) {
    margin-bottom: 1rem;
  }
`;

const Title = styled(Text)`
  min-height: 36px;	
  margin: 0 0 1rem 0 !important;
  color: ${theme.colors.dark};	
  font-family: Inter;	
  font-size: 24px;	
  font-weight: bold;	
  line-height: 36px;
`;

const Body = styled(Col)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`;

const StyledList = styled.ul`
  list-style: none;
  padding-left: 1.5rem;
`;

const StyledListItem = styled.li`
  margin: .5rem 0;
  p {
    color: ${theme.colors.dark};	
    font-family: Inter;	
    font-size: 14px;	
    line-height: 24px;
    display: inline;
  }
  
  &:before {
    content: ""; 
    background-color: ${ props => props.color };
    position: absolute;
    width: 1rem;
    height: 1rem;
    border-radius: 100%;
    margin-left: -1.5rem;
    margin-top: .25rem;
  }
`;

const renderListItem = (name, description) => {
  return (
    <>
      <p><b>{ name }:</b></p> <span dangerouslySetInnerHTML={ { __html: description } } />
    </>
  )
};

function ExperienceLayers(props) {
  const [data, setData] = useState(null);
  const [graphicsData, setGraphicsData] = useState(null);

  useEffect(() => {
    async function fetchData() {
      const result = await apiGet(`/paragraph/experience_layers/${props.id}?include=field_experience_layers`);
      setData(result.data);
      let initGraphicsData = [];
      result.data.included.forEach( item => {
        let name = item.attributes.name;
        let color = item.attributes.field_color.color;
        let description = item.attributes.description.value;
        let field_image = item.relationships.field_image;
        initGraphicsData.push({
          name: name,
          color: color,
          description: description,
          field_image: field_image
        })
      });
      setGraphicsData(initGraphicsData)
    }
    fetchData();
  }, []);

  return (
    <Wrapper>
      {
        data &&
        <>
          <Body
            size={{ xs: '12', sm: '12', md: '5', lg: '6' }}
          >
            <Title
              tag="h3"
            >
              Experience layers
            </Title>
            <Intro
              dangerouslySetInnerHTML={ { __html: data.data.attributes.field_description.value} }
            />
            <StyledList>
              {
                graphicsData && graphicsData.map( item => {
                  return (
                    <StyledListItem
                      key={item.name}
                      color={item.color}
                    >
                    { renderListItem(item.name, item.description) }
                    </StyledListItem>
                  )
                })
              }
            </StyledList>
          </Body>
          <Col
            size={{ xs: '12', sm: '12', md: '7', lg: '6' }}
          >
          { graphicsData &&
            <Fade
              right
              distance={'40px'}
            >
              <ExperienceLayersSvg
                data={graphicsData}
              />
            </Fade>
          }
          </Col>
          <Col
            size={12}
          >
            {
              data.data.attributes.field_link &&
              <SecondaryButton
                text={data.data.attributes.field_link.title}
                url={data.data.attributes.field_link.uri}
              />
            }
          </Col>
        </>
      }
    </Wrapper>
  )
}



export default ExperienceLayers
